import React from "react";
import GAAddQuickTalesToGroupContainer from "../../modules/GAGroups/containers/GAAddQuickTalesToGroupContainer/GAAddQuickTalesToGroupContainer";

const GAAddQuickTalesToGroup = () => {
  return <GAAddQuickTalesToGroupContainer />;
};

export default GAAddQuickTalesToGroup;

